export default __webpack_public_path__ + "images/nydree-logo-white.21afd23db23fc89824220a78b28d2d5e.png";